import type { FaireProductEntity } from "../../entity_types/product";

export const p_3c82fx8qb6: FaireProductEntity = {
  token: "p_3c82fx8qb6",
  type: "product",
  name: "Fresh Bakery Bread Squishy stuffed / stress relief Toy",
  brandToken: "b_a2xtvyskxb",
  brandName: "K-Wonderland",
  imageUrl:
    "https://cdn.faire.com/fastly/96d507b72fcd1a87fddece2b7b9596380d77cd9503ca16425e32f95e75602f0d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58146ac41f452ed21a9fcff0b17d0ee6c42e66105e565f798e65ffac358051b9.jpeg",
    "https://cdn.faire.com/fastly/3579b0ef5499770c960ca24e86895f03e042b98bb76bf82ad9334baff74104f1.jpeg",
    "https://cdn.faire.com/fastly/8afbebab206f733b1675bc07f214e197518daf5ec98cd35a8c79b2fc1a136878.jpeg",
    "https://cdn.faire.com/fastly/870d2edaa4c1b5d3ede79904677044570d443694b62ac3564d150e6168c43717.jpeg",
    "https://cdn.faire.com/fastly/275208758e464e06911198cfd7515b163c61407956d9a1ad345d2a154ee31d68.jpeg",
    "https://cdn.faire.com/fastly/09a85d9a95e0544c6b5c9922eb9462eb8da2489cac90944383a3606e014dc983.jpeg",
    "https://cdn.faire.com/fastly/c7a8bb70b90cbf4ae3db96f818f431f5affd27cbaf4c9bae90dbe150275e9a1b.jpeg",
    "https://cdn.faire.com/fastly/684aaae4e95d360a821081ddc24649a6a91740623539f575557548997758aec8.jpeg",
  ],
  priceDollars: 4.35,
  description:
    "It's a bakery squeeze that you can't eat, but you'll feel better if you keep touching it. \nIt's an item that has a soft and chewy touch and makes you feel even more enjoyable. \nCroissant, salt bread, and cream bread are in one package.\n\nSize: 8.5×8.5×4.3 cm\n\n*Due to increases in raw material costs and rising fuel and air freight charges, our prices have been adjusted. We kindly ask for your understanding in advance.",
  tags: [],
  msrpDollars: 7.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:40.989Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
